import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Banknote, Store, Gavel, ShieldCheck } from "lucide-react";
import TraderVerificationCard from "../components/TraderVerificationCard";
import { VerifiedTraderBadge } from "../components/SouqLive";
import { useApp } from "../context/AppContext";
import { useAuth } from "../context/AuthContext";
import { Skel } from "../components/Skeleton";
import FarmerSouqPanel from "../components/FarmerSouqPanel";
import FarmerPayouts from "../components/FarmerPayouts";

const TABS = [["listings", Gavel], ["payouts", Banknote], ["verification", ShieldCheck]];

export default function TraderDashboard() {
  const { t } = useApp();
  const { user, logout } = useAuth();
  const [tab, setTab] = useState(() => new URLSearchParams(window.location.search).get("tab") || "listings");
  if (user === null) return <main className="dash-page"><Skel h={120} /></main>;
  if (user === false) return <Navigate to="/auth?type=trader" replace />;
  if (!user.is_trader) return <Navigate to="/dashboard" replace />;

  return (
    <main className="dash-page" data-testid="trader-dashboard">
      <header className="dash-header">
        <div>
          <span className="dash-kicker"><Store size={14} /> {t("tr.kicker")}</span>
          <h1 className="dash-title">{t("hub.welcome")}, {user.name}</h1>
          <p className="dash-sub">{user.trader_name || user.farm_name} · {user.trader_verified ? <VerifiedTraderBadge testId="trader-header-vt" /> : <span className="chip">{t("souq.traderListing")}</span>}</p>
        </div>
        <button className="btn-lux-ghost" onClick={logout} data-testid="trader-logout">{t("dash.logout")}</button>
      </header>
      <nav className="dash-tabs" data-testid="trader-tabs">
        {TABS.map(([id, Icon]) => (
          <button key={id} className={`dash-tab ${tab === id ? "active" : ""}`} onClick={() => setTab(id)} data-testid={`trader-tab-${id}`}><Icon size={15} /> {t(`tr.tab.${id}`)}</button>
        ))}
      </nav>
      {tab === "listings" && <FarmerSouqPanel yields={[]} mode="trader" />}
      {tab === "payouts" && <FarmerPayouts />}
      {tab === "verification" && <TraderVerificationCard />}
    </main>
  );
}
